<template lang="pug">
portal(
  v-if="inputValue"
  :to="`${constants.DIALOG_PORTAL_KEY}.content`"
  v-slot="{ close }"
)
  .d-contents
    .mb-7.text-start.text-body-1.redesignBlack--text
      slot(name="text")

    user-requirements-form(
      v-bind="$attrs"
      v-on="$listeners"
      @update="onUpdateProfile(close)"
    )
      template(#save-btn="{ action, loading, disabled }")
        portal(
          :to="`${constants.DIALOG_PORTAL_KEY}.actions`"
          v-slot="{ close }"
        )
          .d-flex.gap-16.full-width
            app-button(
              rounded
              outlined
              large
              @click="close"
            ) Закрыть
            app-button(
              :loading="loading"
              :disabled="disabled"
              rounded
              large
              @click="action"
            ) Сохранить
</template>

<script>
import UserRequirementsForm from '@/components/forms/UserRequirementsForm.vue';
import AppButton from '@/components/user-redesign/controls/AppButton.vue';

const DIALOG_PORTAL_KEY = 'fill-profile-dialog';

export default {
  name: 'UserRequirementsDialog',
  components: {
    UserRequirementsForm,
    AppButton,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    constants() {
      return {
        DIALOG_PORTAL_KEY,
      };
    },
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    inputValue(value) {
      if (!value) {
        return;
      }

      this.openDialog();
    },
  },
  created() {},
  methods: {
    openDialog() {
      this.$dialogs.portal({
        attrs: {
          maxWidth: 800,
          title: 'Заполните профиль',
          inputValue: DIALOG_PORTAL_KEY,
        },
        listeners: {
          close: () => {
            this.hideDialog();
          },
          'click:outside': () => {
            this.hideDialog();
          },
        },
      });
    },
    hideDialog() {
      this.inputValue = false;
    },
    onUpdateProfile(closeFn) {
      this.$emit('update-profile');
      this.hideDialog();
      if (closeFn) closeFn();
    },
  },
};
</script>
